import React, { useState, useEffect } from "react";
import openSocket from "../../services/socket-io";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { toast } from "react-toastify";

import api from "../../services/api";
import { i18n } from "../../translate/i18n.js";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex",
		alignItems: "center",
		padding: theme.spacing(8, 8, 3),
	},

	paper: {
		padding: theme.spacing(2),
		display: "flex",
		alignItems: "center",
		marginBottom: 12,

	},

	settingOption: {
		marginLeft: "auto",
	},
	margin: {
		margin: theme.spacing(1),
	},

}));

const Settings = () => {
	const classes = useStyles();
	const history = useHistory();

	const [settings, setSettings] = useState([]);

	useEffect(() => {
		const fetchSession = async () => {
			try {
				const { data } = await api.get("/settings");
				setSettings(data);
			} catch (err) {
				toastError(err);
			}
		};
		fetchSession();
	}, []);

	useEffect(() => {
		const socket = openSocket();

		socket.on("settings", data => {
			if (data.action === "update") {
				setSettings(prevState => {
					const aux = [...prevState];
					const settingIndex = aux.findIndex(s => s.key === data.setting.key);
					if (settingIndex !== -1) {
						aux[settingIndex].value = data.setting.value;
					} else {
						aux.push(data.setting);
					}
					return aux;
				});
			}
		});

		return () => {
			socket.disconnect();
		};
	}, []);

	const handleChangeSetting = async e => {
		const selectedValue = e.target.value;
		const settingKey = e.target.name;

		try {
			await api.put(`/settings/${settingKey}`, {
				value: selectedValue,
			});
			toast.success(i18n.t("settings.success"));
		} catch (err) {
			toastError(err);
		}
	};

	const getSettingValue = key => {
		const setting = settings.find(s => s.key === key);
		return setting ? setting.value : "";
	};

	return (
		<div className={classes.root}>
			<Container className={classes.container} maxWidth="sm">
				<Typography variant="body2" gutterBottom>
					{i18n.t("settings.title")}
				</Typography>
				<Paper className={classes.paper}>
					<Typography variant="body1">
						{i18n.t("settings.settings.userCreation.name")}
					</Typography>
					<Select
						margin="dense"
						variant="outlined"
						native
						id="userCreation-setting"
						name="userCreation"
						value={
							settings && settings.length > 0 && getSettingValue("userCreation")
						}
						className={classes.settingOption}
						onChange={handleChangeSetting}
					>
						<option value="enabled">
							{i18n.t("settings.settings.userCreation.options.enabled")}
						</option>
						<option value="disabled">
							{i18n.t("settings.settings.userCreation.options.disabled")}
						</option>
					</Select>

				</Paper>

				<Paper className={classes.paper}>
					<TextField
						id="api-token-setting"
						readonly
						label="Token Api"
						margin="dense"
						variant="outlined"
						fullWidth
						value={settings && settings.length > 0 && getSettingValue("userApiToken")}
					/>
				</Paper>

				<Paper className={classes.paper}>
					<TextField
						id="ticket-history-retention-setting"
						label={i18n.t("settings.settings.ticketHistoryRetention.name")}
						type="number"
						margin="dense"
						variant="outlined"
						name="ticketHistoryRetentionDays"
						value={
							settings && settings.length > 0 && getSettingValue("ticketHistoryRetentionDays")
						}
						onChange={handleChangeSetting}
						className={classes.settingOption}
						inputProps={{ min: 1 }}
					/>
					<Typography variant="caption" style={{ marginLeft: 8, color: "#666" }}>
						{i18n.t("settings.settings.ticketHistoryRetention.description")}
					</Typography>
				</Paper>

				<Paper className={classes.paper}>
					<Typography variant="body1">
						Ignorar Notificações de Grupos
					</Typography>
					<Select
						margin="dense"
						variant="outlined"
						native
						id="ignoreGroupMsg-setting"
						name="ignoreGroupMsg"
						value={
							settings && settings.length > 0 && getSettingValue("ignoreGroupMsg")
						}
						className={classes.settingOption}
						onChange={handleChangeSetting}
					>
						<option value="enabled">
							Ativado
						</option>
						<option value="disabled">
							Desativado
						</option>
					</Select>
				</Paper>

				<Paper className={classes.paper}>
					<Typography variant="body1">
						Ocultar Aba de Grupos
					</Typography>
					<Select
						margin="dense"
						variant="outlined"
						native
						id="hideGroupTab-setting"
						name="hideGroupTab"
						value={
							settings && settings.length > 0 && getSettingValue("hideGroupTab")
						}
						className={classes.settingOption}
						onChange={handleChangeSetting}
					>
						<option value="enabled">
							Ativado
						</option>
						<option value="disabled">
							Desativado
						</option>
					</Select>
				</Paper>

			<Paper className={classes.paper} style={{ flexDirection: "column", alignItems: "flex-start", padding: 16 }}>
					<div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
						<span style={{ fontSize: 22 }}>🔄</span>
						<Typography variant="body1" style={{ fontWeight: 700 }}>
							Distribuição Round Robin de Leads
						</Typography>
					</div>
					<Typography variant="body2" style={{ color: "#555", marginBottom: 8 }}>
						Distribui tickets pendentes automaticamente entre os agentes de uma fila de forma igualitária.
						O sistema seleciona sempre o agente com menos atendimentos abertos no dia.
						Em caso de empate, a escolha é feita por sorteio.
					</Typography>
					<Typography variant="caption" style={{ color: "#888", marginBottom: 12, display: "block" }}>
						<strong>Exemplo:</strong> 15 contatos + 10 vendedores = cada um recebe 1 lead,
						e 5 agentes são sorteados para receber o lead extra.
					</Typography>
					<Button
						variant="outlined"
						color="primary"
						size="small"
						onClick={() => history.push("/queues")}
						style={{ borderRadius: 8, textTransform: "none", fontWeight: 600 }}
					>
						⚙️ Configurar nas Filas
					</Button>
				</Paper>

			</Container>
		</div>
	);
};

export default Settings;
